export default "/images/product-detail-out-of-stock.png";